import produce, { castDraft, } from 'immer';
import { BaseActionType, } from '@moderepo/mode-data-state-base';
import { appStateReducer, } from './appState/reducers';
import { authStateReducer, } from './authState/reducers';
import { projectsStateReducer, } from './projectState/reducers';
import { agentsStateReducer, } from './projectAgentsState/reducers';
import { agentLogsStateReducer, } from './agentLogsState/reducers';
import { usersStateReducer, } from './usersState/reducers';
import { userLogsStateReducer, } from './userLogsState/reducers';
import { homeLogsStateReducer, } from './homeLogsState/reducers';
import { deviceClassesStateReducer, } from './deviceClassesState/reducers';
import { projectDevicesStateReducer, } from './projectDevicesState/reducers';
import { deviceLogsStateReducer, } from './deviceLogsState/reducers';
import { homesStateReducer, } from './homesState';
import { metricsReportSubscriptionsStateReducer, } from './metricsReportSubscriptionsState';
import { organizationsStateReducer, } from './organizationsState';
import { firmwareStateReducer, } from '.';
/**
 * This is the root reducer for the Ritz data state. It will be the starting point for data state reducer. It actually doesn't
 * handle any action other than the BatchAction. It will escalate all the tasks to each individual sub state
 *
 * @param currentState
 * @param action
 */
export const ritzDataStateReducer = (currentState, action) => {
    const { type } = action;
    switch (type) {
        case BaseActionType.BATCH_ACTIONS:
            return produce(currentState, () => {
                const actualAction = action;
                return actualAction.actions.reduce((state, a) => {
                    return ritzDataStateReducer(state, a);
                }, currentState);
            });
        default:
            // Apply reducer for each individual domain.
            return produce(currentState, (draft) => {
                draft.organizations = castDraft(organizationsStateReducer(currentState.organizations, action));
                draft.app = appStateReducer(currentState.app, action);
                draft.auth = authStateReducer(currentState.auth, action);
                draft.projects = castDraft(projectsStateReducer(currentState.projects, action));
                draft.projectAgents = castDraft(agentsStateReducer(currentState.projectAgents, action));
                draft.agentLogs = castDraft(agentLogsStateReducer(currentState.agentLogs, action));
                draft.users = castDraft(usersStateReducer(currentState.users, action));
                draft.userLogs = castDraft(userLogsStateReducer(currentState.userLogs, action));
                draft.homeLogs = castDraft(homeLogsStateReducer(currentState.homeLogs, action));
                draft.homes = castDraft(homesStateReducer(currentState.homes, action));
                draft.deviceClasses = castDraft(deviceClassesStateReducer(currentState.deviceClasses, action));
                draft.projectDevices = castDraft(projectDevicesStateReducer(currentState.projectDevices, action));
                draft.firmware = castDraft(firmwareStateReducer(currentState.firmware, action));
                draft.deviceLogs = castDraft(deviceLogsStateReducer(currentState.deviceLogs, action));
                draft.metricsReportSubscriptions = castDraft(metricsReportSubscriptionsStateReducer(currentState.metricsReportSubscriptions, action));
            });
    }
};
